export interface Message {
    concernType: string;
    concernId: number;
    messageContent: string;
    languageId: number;
    brandId: number;
    phoneServiceId: number;
    customerId: number;
    userAccountId: number;
}

export interface FeedbackFormData {
    additionalText: string | null;
    company : string | null;
    email: string | null;
    firstName: string | null;
    lastName: string | null;
    salutation: string | null;
    rating: number | null;
}

export class Feedback {
    private readonly additionalText: string | null;
    private readonly company: string | null;
    private readonly email: string | null;
    private readonly firstName: string | null;
    private readonly lastName: string | null;
    private readonly salutation: string | null;
    private readonly rating: number | null;
    
    constructor(feedbackData: FeedbackFormData) {
        this.additionalText = feedbackData.additionalText;
        this.company = feedbackData.company;
        this.email = feedbackData.email;
        this.firstName = feedbackData.firstName;
        this.lastName = feedbackData.lastName;
        this.salutation = feedbackData.salutation;
        this.rating = feedbackData.rating;
    }
    
    public getSendData() {
        let data = `Please get in contact with`;
        let name = `${!!this.salutation? this.salutation + ' ' : ''}${!!this.firstName? this.firstName + ' ' : ''}${this.lastName}`;
        data = data.concat(`${name}\n`);
        if (!!this.company) data = data.concat(`${this.company}\n`);
        if (!!this.email) data = data.concat(`${this.email}\n`);
        if (!!this.rating) data = data.concat(`Received rating: ${this.rating}\n`);
        if (!!this.additionalText) data = data.concat(`${this.additionalText}`);
        
        return data;

    }
}
